import apiClient from '../http-common'

export const GLOBALS_ENDPOINT = '/globals'

export const fetchGlobals = () =>
  apiClient.get(`${GLOBALS_ENDPOINT}/`).then((res) => res.data)
